import React, { useState, useEffect, useContext, useRef } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { fetchData } from "../../../utils/methods";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import MessageAlert from "../../MessageAlert/MessageAlert";
import { useAlert } from "../../../utils/AlertContext";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { icons } from "../../../constants";
import { apiRoutes } from "../../../utils/apiRoutes";

const Languages = ({
  setIsBarOpen,
  setLanguageGeneral,
  openLanguages,
  setOpenLanguages,
  small = false,
  variant = "dropdown",
}) => {
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "sr"
  );
  const [languages, setLanguages] = useState([]);
  const [sortedLanguages, setSortedLanguages] = useState([]);
  const [errorMessageAlert, setErrorMessageAlert] = useState("");
  const languageRef = useRef(null);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { t } = useContext(TranslationsContext);
  const theme = localStorage.getItem("theme") || "light";

  useEffect(() => {
    const getData = async () => {
      setIsLoadingData(true);
      const result = await fetchData(
        apiRoutes.getLanguages,
        showAlert,
        navigate,
        t
      );
      if (result) setLanguages(result.data);
      setIsLoadingData(false);
    };
    getData();
  }, []);

  useEffect(() => {
    if (languages.length > 0) {
      const sorted = [
        ...languages.filter((lang) => lang === language),
        ...languages.filter((lang) => lang !== language),
      ];
      setSortedLanguages(sorted);
    }
  }, [languages, language]);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleClickLanguage = (lang) => {
    setLanguage(lang);
    setLanguageGeneral(lang);
    setIsBarOpen(false);
    setOpenLanguages(false); // ✅ zatvori
  };

  if (variant === "inline") {
    return (
      <>
        {isLoadingData ? (
          <Loader />
        ) : (
          <div className="flex-direction-row items-center language-inline-list">
            {languages.map((lang) => (
              <p
                key={lang}
                className={`font-12 inria-sans-700 uppercase pointer language-inline-item ${
                  lang === language ? "language-inline-item--active" : ""
                }`}
                onClick={() => handleClickLanguage(lang)}
              >
                {lang}
              </p>
            ))}
          </div>
        )}

        {errorMessageAlert && (
          <MessageAlert
            message={errorMessageAlert}
            type={"error"}
            onClose={() => setErrorMessageAlert("")}
          />
        )}
      </>
    );
  }

  return (
    <>
      {isLoadingData ? (
        <Loader />
      ) : (
        <div
          ref={languageRef}
          className={`flex-direction-row navbar-languages-wrapper ${
            openLanguages ? "hovered" : ""
          }`}
          onMouseEnter={!small ? () => setOpenLanguages(true) : undefined}
          onMouseLeave={!small ? () => setOpenLanguages(false) : undefined}
        >
          <div
            className="flex-direction-row items-center justify-center pointer selected-language"
            onClick={
              small ? () => setOpenLanguages((prev) => !prev) : undefined
            }
          >
            <p className="font-12 inria-sans-700 uppercase">
              {sortedLanguages[0] || ""}
            </p>
            {/* {small && (
              <img
                src={
                  theme === "light" ? icons.arrow_down : icons.arrow_down_dark
                }
                style={{
                  transform: !openLanguages ? "rotate(0)" : "rotate(180deg)",
                  transition: "transform 0.1s ease",
                }}
                width={20}
                height={20}
              />
            )} */}
          </div>

          {openLanguages && (
            <div
              className="flex-direction-row items-center other-languages-wrapper"
              ref={languageRef}
            >
              {sortedLanguages.slice(1).map((lang) => (
                <div
                  key={lang}
                  className="flex-direction-row items-center justify-center pointer other-language"
                  onClick={() => handleClickLanguage(lang)}
                >
                  <p className="font-12 inria-sans-700 uppercase">{lang}</p>
                </div>
              ))}
            </div>
          )}

          {errorMessageAlert && (
            <MessageAlert
              message={errorMessageAlert}
              type={"error"}
              onClose={() => setErrorMessageAlert("")}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Languages;
